import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Sync = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M21 12C21 16.968 16.968 21 12 21C7.032 21 3.999 15.996 3.999 15.996M3.999 15.996H8.067M3.999 15.996V20.496M3 12C3 7.032 6.996 3 12 3C18.003 3 21 8.004 21 8.004M21 8.004V3.504M21 8.004H17.004",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
